import { render, staticRenderFns } from "./DoctorsAssistant.vue?vue&type=template&id=0e1314b3&scoped=true"
import script from "./DoctorsAssistant.vue?vue&type=script&lang=js"
export * from "./DoctorsAssistant.vue?vue&type=script&lang=js"
import style0 from "./DoctorsAssistant.vue?vue&type=style&index=0&id=0e1314b3&prod&scoped=true&lang=css"
import style1 from "./DoctorsAssistant.vue?vue&type=style&index=1&id=0e1314b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1314b3",
  null
  
)

export default component.exports